export default __webpack_public_path__ + "static/media/img_10.e460fb63.jpg";